export default __webpack_public_path__ + "static/media/prm-marketplace-logo.4181146e.png";